import { getFunctions } from 'firebase/functions';
import { app } from '../../config/firebase';

export const functions = getFunctions(app, 'us-central1');

// G11 (Principal Due-Diligence) deploys to europe-west1 — it runs LLM
// principal extraction + per-principal OFAC SDN lookups, which were too
// heavy for us-central1's cold-start budget. See functions/shield-g11-cloud-function.js.
export const functionsEuropeWest1 = getFunctions(app, 'europe-west1');
